module.exports = __webpack_public_path__ + "img/image-05.80fa1030.svg";